import axios from "axios";
import { Alert } from "react-bootstrap";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  ADMIN_GET_ALL_ORDER_ACTIVITY,
  ADMIN_GET_ALL_PENDING_ACTIVITY,
  ADMIN_GET_ALL_ORDERING_DASHBOARD,
} from "../../types";
import { setErrors } from "../errorActions";

/***************************************
 * @DESC ADMIN GET ALL ORDER ACTVITY
 ***************************************/
export const admin_get_all_activity = (token, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    const admin_get_all_activity = await axios.get(
      `${serverApi}/admin/orders?orderType=all&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: { Authorization: token },
      }
    );
    if (admin_get_all_activity.status === 200) {
      dispatch({
        type: ADMIN_GET_ALL_ORDER_ACTIVITY,
        payload: admin_get_all_activity.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC ADMIN GET ALL PENDING ORDER ACTVITY
 ***************************************/
export const admin_get_all_pending_activity = (token, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    const admin_get_all_pending_activity = await axios.get(
      `${serverApi}/admin/orders?orderType=pending&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: { Authorization: token },
      }
    );
    if (admin_get_all_pending_activity.status === 200) {
      dispatch({
        type: ADMIN_GET_ALL_PENDING_ACTIVITY,
        payload: admin_get_all_pending_activity.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC ADMIN GET ALL ORDER ACTVITY
 ***************************************/
export const admin_get_all_order_dashboard = (token, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    const admin_get_all_order_dashboard = await axios.get(
      `${serverApi}/admin/orders?groupBy=true&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: { Authorization: token },
      }
    );
    if (admin_get_all_order_dashboard.status === 200) {
      dispatch({
        type: ADMIN_GET_ALL_ORDERING_DASHBOARD,
        payload: admin_get_all_order_dashboard.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};
